import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import CreateButton from './creation/button';

export function DealsHeader({ listings, path, onNewDeal }) {
  return (
    <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
      <h5>Deals</h5>
      <CreateButton {...listings} path={path} onNewDeal={onNewDeal} />
    </div>
  );
}

DealsHeader.propTypes = {
  listings: PropTypes.object,
  path: PropTypes.string.isRequired,
  onNewDeal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  listings: state.dealsTab.listings,
});

export default connect(mapStateToProps)(DealsHeader);
